var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM9.7 12C9.7 10.7297 10.7297 9.7 12 9.7C13.2703 9.7 14.3 10.7297 14.3 12C14.3 13.2703 13.2703 14.3 12 14.3C10.7297 14.3 9.7 13.2703 9.7 12ZM12 8.3C9.95655 8.3 8.3 9.95655 8.3 12C8.3 14.0435 9.95655 15.7 12 15.7C14.0435 15.7 15.7 14.0435 15.7 12C15.7 9.95655 14.0435 8.3 12 8.3Z",
    fill: "#6F2DBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisc);
export default __webpack_public_path__ + "static/media/disc.858f203472aacdda4e605a4cfb82719e.svg";
export { ForwardRef as ReactComponent };